(function () {
	'use strict';

	var CONFIG = {
		mode: 'auto',
		storeUrls: {
			international: 'https://woomii.com',
			japan: 'https://woomii.jp'
		},
		storeHostnames: {
			international: ['woomii.com'],
			japan: ['woomii.jp']
		},
		japanCountryCode: 'JP',
		preferenceCookieName: 'navy_store_location_preference_v3',
		preferenceCookieDays: 180,
		preferenceQueryParam: 'navy_store_preference',
		preservePath: true,
		localePrefixesToStrip: ['en', 'ja', 'ko', 'th', 'ms'],
		excludedPathPrefixes: ['/cart', '/checkout', '/account', '/challenge', '/password'],
		titles: {
			en: 'WELCOME TO WOOMII',
			ja: 'WOOMIIへようこそ'
		},
		copy: {
			international: {
				en: {
					question: 'Shopping from Japan?',
					message: 'Discover our Japan store, with local pricing, shipping and customer care.',
					switchLabel: 'Go to Japan store',
					stayLabel: 'Stay on international store',
					closeLabel: 'Stay on international store'
				},
				ja: {
					question: '日本からのお買い物ですか？',
					message: '日本ストアなら、日本向けの価格・配送・カスタマーサポートをご利用いただけます。',
					switchLabel: '日本ストアへ',
					stayLabel: 'インターナショナルストアを利用',
					closeLabel: 'インターナショナルストアを利用'
				}
			},
			japan: {
				en: {
					question: 'Shopping from outside Japan?',
					message: 'Explore our international store, with local pricing, shipping and customer care.',
					switchLabel: 'Go to International Store',
					stayLabel: 'Stay on Japan Store',
					closeLabel: 'Stay on Japan Store'
				},
				ja: {
					question: '日本国外からお買い物ですか？',
					message: '国際配送、現地通貨での価格表示、カスタマーケアをご案内しています。',
					switchLabel: 'インターナショナルストアへ',
					stayLabel: '日本サイトにとどまる',
					closeLabel: '日本サイトにとどまる'
				}
			}
		}
	};

	var MODAL_ID = 'NavyStoreLocationModal';
	var STYLE_ID = 'NavyStoreLocationModalStyles';
	var VALID_MODES = ['international', 'japan'];
	var countryDetection;

	function isValidMode(value) {
		return VALID_MODES.indexOf(value) !== -1;
	}

	function normalizeHostname(value) {
		return String(value || '').toLowerCase().replace(/^www\./, '');
	}

	function getStoreUrl(mode) {
		if (!isValidMode(mode)) return null;

		try {
			var url = new URL(CONFIG.storeUrls[mode]);
			if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
			return url;
		} catch (error) {
			return null;
		}
	}

	function matchesStoreHostname(mode, currentHostname) {
		var configuredHostnames = CONFIG.storeHostnames[mode] || [];
		var matchesAlias = configuredHostnames.some(function (hostname) {
			return normalizeHostname(hostname) === currentHostname;
		});

		if (matchesAlias) return true;

		var storeUrl = getStoreUrl(mode);
		return !!(
			storeUrl &&
			normalizeHostname(storeUrl.hostname) === currentHostname
		);
	}

	function getCurrentStoreMode() {
		if (isValidMode(CONFIG.mode)) return CONFIG.mode;

		var currentHostname = normalizeHostname(window.location.hostname);

		if (matchesStoreHostname('japan', currentHostname)) {
			return 'japan';
		}

		if (matchesStoreHostname('international', currentHostname)) {
			return 'international';
		}

		return 'international';
	}

	function normalizeLocale(value) {
		var normalized = String(value || '').toLowerCase().replace('_', '-');
		return normalized.split('-')[0];
	}

	function getCurrentLocale() {
		var pathLocale = normalizeLocale(
			String(window.location.pathname || '/').split('/')[1]
		);

		if (pathLocale === 'en' || pathLocale === 'ja') {
			return pathLocale;
		}

		var documentLocale = normalizeLocale(document.documentElement.lang);
		return documentLocale === 'ja' ? 'ja' : 'en';
	}

	function getCookie(name) {
		var match = document.cookie.match('(?:^|;)\\s*' + name + '=([^;]*)');
		return match ? decodeURIComponent(match[1]) : null;
	}

	function setCookie(name, value, days) {
		var maxAge = Math.round(days * 24 * 60 * 60);
		var secure = window.location.protocol === 'https:' ? '; Secure' : '';
		document.cookie =
			name +
			'=' +
			encodeURIComponent(value) +
			'; Max-Age=' +
			maxAge +
			'; Path=/; SameSite=Lax' +
			secure;
	}

	function deleteCookie(name) {
		document.cookie =
			name +
			'=; Max-Age=0; Path=/; SameSite=Lax' +
			(window.location.protocol === 'https:' ? '; Secure' : '');
	}

	function consumePreferenceQueryParam() {
		try {
			var currentUrl = new URL(window.location.href);
			var preference = currentUrl.searchParams.get(CONFIG.preferenceQueryParam);

			if (!isValidMode(preference)) return;

			setCookie(CONFIG.preferenceCookieName, preference, CONFIG.preferenceCookieDays);
			currentUrl.searchParams.delete(CONFIG.preferenceQueryParam);
			window.history.replaceState({}, document.title, currentUrl.toString());
		} catch (error) {}
	}

	function hasStoredPreference() {
		return isValidMode(getCookie(CONFIG.preferenceCookieName));
	}

	function isExcludedPath() {
		var pathname = stripLocalePrefix(window.location.pathname).toLowerCase();

		return CONFIG.excludedPathPrefixes.some(function (prefix) {
			return pathname === prefix || pathname.indexOf(prefix + '/') === 0;
		});
	}

	function parseDetectedCountry(data) {
		if (
			data &&
			data.detected_values &&
			data.detected_values.country &&
			data.detected_values.country.handle
		) {
			return String(data.detected_values.country.handle).toUpperCase();
		}

		if (data && data.country && data.country.handle) {
			return String(data.country.handle).toUpperCase();
		}

		return null;
	}

	function getCountrySuggestionEndpoint() {
		var routesRoot =
			window.Shopify &&
			window.Shopify.routes &&
			window.Shopify.routes.root
				? window.Shopify.routes.root
				: '/';
		var rootUrl = new URL(routesRoot, window.location.origin);
		return new URL(
			'browsing_context_suggestions.json?country[enabled]=true',
			rootUrl
		).toString();
	}

	function detectCountry() {
		if (countryDetection) return countryDetection;

		countryDetection = fetch(getCountrySuggestionEndpoint(), {
			cache: 'no-store',
			credentials: 'same-origin'
		})
			.then(function (response) {
				if (!response.ok) throw new Error('Country detection failed');
				return response.json();
			})
			.then(parseDetectedCountry);
		return countryDetection;
	}

	function shouldShowModal(currentMode, detectedCountry) {
		if (!detectedCountry) return false;

		if (currentMode === 'japan') {
			return detectedCountry !== CONFIG.japanCountryCode;
		}

		return detectedCountry === CONFIG.japanCountryCode;
	}

	function stripLocalePrefix(pathname) {
		var pathParts = String(pathname || '/').split('/');
		var firstPathPart = (pathParts[1] || '').toLowerCase();

		if (CONFIG.localePrefixesToStrip.indexOf(firstPathPart) !== -1) {
			pathParts.splice(1, 1);
		}

		var strippedPath = pathParts.join('/');
		return strippedPath || '/';
	}

	function buildDestinationUrl(targetMode) {
		var destination = getStoreUrl(targetMode);
		if (!destination) return null;

		if (CONFIG.preservePath) {
			var destinationBasePath = destination.pathname.replace(/\/+$/, '');
			var sourcePath = stripLocalePrefix(window.location.pathname);
			destination.pathname = (destinationBasePath + sourcePath).replace(/\/+/g, '/');

			var sourceParams = new URLSearchParams(window.location.search);
			sourceParams.delete('currency');
			sourceParams.delete(CONFIG.preferenceQueryParam);
			sourceParams.forEach(function (value, key) {
				destination.searchParams.set(key, value);
			});
			destination.hash = window.location.hash;
		}

		destination.searchParams.set(CONFIG.preferenceQueryParam, targetMode);
		return destination.toString();
	}

	function injectStyles() {
		if (document.getElementById(STYLE_ID)) return;

		var style = document.createElement('style');
		style.id = STYLE_ID;
		style.textContent =
			'#' +
			MODAL_ID +
			'{width:min(520px,calc(100% - 32px));max-width:520px;max-height:calc(100vh - 32px);max-height:calc(100dvh - 32px);padding:0;border:0;border-radius:20px;background:#fff;color:#111;box-shadow:0 24px 80px rgba(0,0,0,.24);overflow-x:hidden;overflow-y:auto}' +
			'#' +
			MODAL_ID +
			'::backdrop{background:rgba(0,0,0,.5);backdrop-filter:blur(3px)}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__inner{position:relative;padding:42px 38px 34px;text-align:center}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__close{position:absolute;top:14px;right:14px;width:36px;height:36px;padding:0;border:0;border-radius:0;background:transparent;color:#111;font-size:28px;line-height:1;cursor:pointer}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__close:hover{background:#f2f2f2}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__title{margin:0;font-size:clamp(24px,5vw,34px);font-weight:700;line-height:1.2}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__line{display:block}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__title .navy-store-modal__line[lang="ja"]{margin-top:5px;font-size:clamp(22px,.78em,27px);font-weight:700;line-height:1.4}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__question{max-width:430px;margin:16px auto 0;font-size:18px;font-weight:600;line-height:1.5}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__question .navy-store-modal__line[lang="ja"]{margin-top:3px;font-size:.94em}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__message{max-width:430px;margin:8px auto 0;font-size:16px;line-height:1.6;color:#4a4a4a}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__message .navy-store-modal__line[lang="ja"]{margin-top:4px}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__actions{display:grid;gap:10px;margin-top:28px}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__button{min-height:48px;padding:12px 18px;border:1px solid #111;border-radius:0;font:inherit;font-size:16px;font-weight:700;line-height:1.4;cursor:pointer}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__button .navy-store-modal__line[lang="ja"]{margin-top:3px;font-weight:600}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__button--switch{background:#111;color:#fff}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__button--stay{background:#fff;color:#111}' +
			'#' +
			MODAL_ID +
			' .navy-store-modal__button:focus-visible,#' +
			MODAL_ID +
			' .navy-store-modal__close:focus-visible{outline:3px solid #4d90fe;outline-offset:3px}' +
			'@media(max-width:479px){#' +
			MODAL_ID +
			' .navy-store-modal__inner{padding:38px 20px 24px}}';
		document.head.appendChild(style);
	}

	function closeModal(modal) {
		if (typeof modal.close === 'function') {
			modal.close();
		} else {
			modal.removeAttribute('open');
		}
	}

	function saveStayPreference(modal, currentMode) {
		setCookie(
			CONFIG.preferenceCookieName,
			currentMode,
			CONFIG.preferenceCookieDays
		);
		closeModal(modal);
	}

	function appendBilingualCopy(element, english, japanese) {
		var englishLine = document.createElement('span');
		var japaneseLine = document.createElement('span');

		englishLine.className = 'navy-store-modal__line';
		englishLine.lang = 'en';
		englishLine.textContent = english;
		japaneseLine.className = 'navy-store-modal__line';
		japaneseLine.lang = 'ja';
		japaneseLine.textContent = japanese;

		element.appendChild(englishLine);
		element.appendChild(japaneseLine);
	}

	function createModal(currentMode) {
		var existingModal = document.getElementById(MODAL_ID);
		if (existingModal) return existingModal;

		var targetMode = currentMode === 'japan' ? 'international' : 'japan';
		var isBilingual = currentMode === 'international';
		var currentLocale = isBilingual ? 'en' : getCurrentLocale();
		var copy = CONFIG.copy[currentMode][currentLocale];
		var japaneseCopy = isBilingual ? CONFIG.copy.international.ja : null;
		var modal = document.createElement('dialog');
		var inner = document.createElement('div');
		var closeButton = document.createElement('button');
		var title = document.createElement('h2');
		var question = document.createElement('p');
		var message = document.createElement('p');
		var actions = document.createElement('div');
		var switchButton = document.createElement('button');
		var stayButton = document.createElement('button');

		modal.id = MODAL_ID;
		modal.setAttribute('aria-labelledby', MODAL_ID + 'Title');
		modal.setAttribute(
			'aria-describedby',
			MODAL_ID + 'Question ' + MODAL_ID + 'Message'
		);

		inner.className = 'navy-store-modal__inner';

		closeButton.type = 'button';
		closeButton.className = 'navy-store-modal__close';
		closeButton.setAttribute(
			'aria-label',
			isBilingual ? copy.closeLabel + ' / ' + japaneseCopy.closeLabel : copy.closeLabel
		);
		closeButton.textContent = '×';

		title.id = MODAL_ID + 'Title';
		title.className = 'navy-store-modal__title';
		if (isBilingual) {
			appendBilingualCopy(title, CONFIG.titles.en, CONFIG.titles.ja);
		} else {
			title.textContent = CONFIG.titles[currentLocale];
		}

		question.id = MODAL_ID + 'Question';
		question.className = 'navy-store-modal__question';
		if (isBilingual) {
			appendBilingualCopy(question, copy.question, japaneseCopy.question);
		} else {
			question.textContent = copy.question;
		}

		message.id = MODAL_ID + 'Message';
		message.className = 'navy-store-modal__message';
		if (isBilingual) {
			appendBilingualCopy(message, copy.message, japaneseCopy.message);
		} else {
			message.textContent = copy.message;
		}

		actions.className = 'navy-store-modal__actions';

		switchButton.type = 'button';
		switchButton.className =
			'navy-store-modal__button navy-store-modal__button--switch';
		if (isBilingual) {
			appendBilingualCopy(switchButton, copy.switchLabel, japaneseCopy.switchLabel);
		} else {
			switchButton.textContent = copy.switchLabel;
		}

		stayButton.type = 'button';
		stayButton.className =
			'navy-store-modal__button navy-store-modal__button--stay';
		if (isBilingual) {
			appendBilingualCopy(stayButton, copy.stayLabel, japaneseCopy.stayLabel);
		} else {
			stayButton.textContent = copy.stayLabel;
		}

		actions.appendChild(switchButton);
		actions.appendChild(stayButton);
		inner.appendChild(closeButton);
		inner.appendChild(title);
		inner.appendChild(question);
		inner.appendChild(message);
		inner.appendChild(actions);
		modal.appendChild(inner);
		document.body.appendChild(modal);

		closeButton.addEventListener('click', function () {
			closeModal(modal);
		});

		stayButton.addEventListener('click', function () {
			saveStayPreference(modal, currentMode);
		});

		switchButton.addEventListener('click', function () {
			var destinationUrl = buildDestinationUrl(targetMode);
			if (!destinationUrl) return;

			setCookie(
				CONFIG.preferenceCookieName,
				targetMode,
				CONFIG.preferenceCookieDays
			);
			window.location.assign(destinationUrl);
		});

		modal.addEventListener('cancel', function (event) {
			event.preventDefault();
			closeModal(modal);
		});

		modal.addEventListener('click', function (event) {
			if (event.target === modal) {
				closeModal(modal);
			}
		});

		return modal;
	}

	function showModal(currentMode) {
		var targetMode = currentMode === 'japan' ? 'international' : 'japan';
		var targetUrl = getStoreUrl(targetMode);

		if (!targetUrl) return;
		if (normalizeHostname(targetUrl.hostname) === normalizeHostname(window.location.hostname)) {
			return;
		}

		// Japan visitors go straight to the Japan store without creating a dialog.
		if (currentMode === 'international') {
			var destinationUrl = buildDestinationUrl('japan');
			if (!destinationUrl) return false;
			window.location.replace(destinationUrl);
			return true;
		}

		injectStyles();
		var modal = createModal(currentMode);

		if (typeof modal.showModal === 'function') {
			if (!modal.open) modal.showModal();
		} else {
			modal.setAttribute('open', '');
		}
	}

	function run() {
		consumePreferenceQueryParam();

		if (isExcludedPath()) return;
		if (window.Shopify && window.Shopify.designMode) return;

		var currentMode = getCurrentStoreMode();
		// Old popup choices must not suppress Japan IP redirects on the international store.
		if (currentMode === 'japan' && hasStoredPreference()) return;

		return detectCountry()
			.then(function (detectedCountry) {
				if (shouldShowModal(currentMode, detectedCountry)) {
					return showModal(currentMode);
				}
			})
			.catch(function () {});
	}

	window.NavyStoreLocationModal = {
		config: CONFIG,
		getCurrentStoreMode: getCurrentStoreMode,
		detectCountry: detectCountry,
		clearPreference: function () {
			deleteCookie(CONFIG.preferenceCookieName);
		},
		showForCountry: function (countryCode) {
			var currentMode = getCurrentStoreMode();
			var detectedCountry = String(countryCode || '').toUpperCase();

			if (shouldShowModal(currentMode, detectedCountry)) {
				showModal(currentMode);
			}
		}
	};

	// Currency redirects wait for this decision so they cannot interrupt a store redirect.
	window.NavyStoreLocationModal.ready = new Promise(function (resolve) {
		function start() {
			resolve(run());
		}
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', start);
		} else {
			start();
		}
	});
})();
